module.exports = __webpack_public_path__ + "static/media/Screenshot_6-thumb.32b2ac4d.png";